import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Container, Paper, Typography, TextField, 
  Button, Divider, List, ListItem, 
  ListItemText, Radio, RadioGroup, 
  FormControlLabel, FormLabel, Box,
  Chip, Checkbox, Alert
} from '@mui/material';
import { 
  LocalOffer, Savings, Loyalty, 
  Info as InfoIcon 
} from '@mui/icons-material';
import noPhoto from "../assets/no_photo.webp";
import keywordsData from '../lang/keywords.json';
import GoogleMapModal from "../components/GoogleMapModal";
import MyLocationIcon from '@mui/icons-material/MyLocation';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
// Animation variants for fade in and hover effect.
const styles = {
    actionButton: {
      backgroundColor: '#471ee9ff',
      color: 'white',
      borderRadius: '20px',
      px: 3,
      py: 1,
      textTransform: 'none',
      fontWeight: 600,
      marginTop:5,
      '&:hover': {
        backgroundColor: '#553eb0ff'
      }
  },
    lcathionactionButton: {
      backgroundColor: '#1565c0',
      color: 'white',
      borderRadius: '40px',
      px: 1,
      py: 1,
      textTransform: 'none',
      fontWeight: 600,
      '&:hover': {
        backgroundColor: '#553eb0ff'
      }
  }
}
const CheckoutPage = () => {
  const { 
    cart, 
    cartTotal, 
    totalSavings, 
    clearCart,
    getItemPrice,
    getOriginalPrice,
    hasDiscount,
    deliverFees
  } = useCart();
  let debounceTimeout; // Global debounce timeout variable
  const { user } = useAuth();
  const navigate = useNavigate();
  const [paymentMethod, setPaymentMethod] = useState('cash_on_delivery');
  const [shippingAddress, setShippingAddress] = useState('');
  const [shippingPoint, setShippingPoint] = useState({ longitude: 0.0 , latitude: 0.0 });
  const [isProcessing, setIsProcessing] = useState(false);
  const [usePoints, setUsePoints] = useState(false);
  const [userPoints, setUserPoints] = useState(0);
  const [pointsError, setPointsError] = useState('');

  const [suggestions, setSuggestions] = useState([]);
  const [open, setOpen] = useState(false);
  const [isSelectMap, setIsSelectMap] = useState(false);
  const [location, setLocation] = useState({ lat: null, lng: null });
  const [selectedLocation, setSelectedLocation] = useState(null);
  const language = 'ar'
  const [isCheackLocation, SetIsCheackLocation] = useState(() => {
    // Attempt to load the user from localStorage
    const checkIsLocated = localStorage.getItem('is_check_location') === 'true';
    if(checkIsLocated) {
        try { 
            const savedLocation = JSON.parse(localStorage.getItem("location_data"));
            setShippingPoint({longitude:savedLocation.lng,latitude:savedLocation.lat})
            //handleFilterChange('userLng', savedLocation.lng);
            //handleFilterChange('userLat', savedLocation.lat);
        } catch(error) {
            checkIsLocated = false;
        }
    }
    return checkIsLocated ;
  });
  const [query, setQuery] = useState(() => {
    const savedLocation = JSON.parse(localStorage.getItem("location_data"));
    if(savedLocation) {
      setShippingAddress(savedLocation.address)
      return savedLocation.address;
    } else {
      return "" ;
    }
  });

  const fetchPlaces = async (input) => {
    if(isSelectMap) {
      return;
    }
    const response = await api.get(`/autocomplete?input=${input}&language=${language}`);
    const data = response.data;
    if (data.predictions) {
      setSuggestions(data.predictions.map((place) => place.description));
    }
  };

  const loadGoogleMapsAPI = (callback) => {
    if (window.google && window.google.maps) {
      callback();
      return;
    }
  
    if (!document.getElementById("google-maps-script")) {
      const script = document.createElement("script");
      var api = 'AIzaSyBl9P55wDymA5tQzFgWFaZWgMyQMdOSWXA';
      script.id = "google-maps-script";
      script.src = `https://maps.googleapis.com/maps/api/js?key=${api}&libraries=places`;
      script.async = true;
      script.defer = true;
      api = '';
      script.onload = () => {
        console.log("Google Maps API Loaded");
        callback(); // ✅ Run the function after loading
      };
  
      script.onerror = () => {
        console.error("Failed to load Google Maps API.");
      };
  
      document.body.appendChild(script);
    } else {
      // If script is already being added but not yet loaded, wait and retry
      setTimeout(() => {
        if (window.google && window.google.maps) {
          callback();
        }
      }, 1000);
    }
  };  
  

  const handleLocationSelect = (location) => {
    if (!window.google || !window.google.maps) {
      console.error("Google Maps API is not loaded yet.");
      loadGoogleMapsAPI(() => handleLocationSelect(location)); // 🔄 Try again after loading
      return;
    }
    if(location.address) {
      setQuery(location.address);
      localStorage.setItem('location_data',JSON.stringify(location));
      setShippingPoint({longitude:location.lng,latitude:location.lat});
      setShippingAddress(location.address);
      //handleFilterChange('userLng', location.lng);
      //handleFilterChange('userLat', location.lat);
      SetIsCheackLocation(true);
      setIsSelectMap(true);
    } else {
      setQuery(location);
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: location }, (results, status) => {
        if (status === "OK" && results[0]) {
          const locationSet = results[0].geometry.location;
          setSelectedLocation({
            lat: locationSet.lat(),
            lng: locationSet.lng(),
            address: location,
          });
          //setQuery(place);
          setOpen(true);
        }
      });
    }
    setSuggestions([]);
  };

  const handleAutoDetect = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
        setOpen(true); // Open the modal
      },
      (error) => {
        alert(language === 'ar' ? keywordsData.enable_gps_ar : keywordsData.enable_gps_en);
      }
    );
  };

  const handleQueryChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    setShippingAddress(value)
    clearTimeout(debounceTimeout); // Clear any existing timeout
    debounceTimeout = setTimeout(() => {
      if (value.length > 2) {
        fetchPlaces(value);
      } else {
        setSuggestions([]); // Clear suggestions if query is too short
      }
    }, 500); // 500ms delay before calling fetchPlaces
  };

  // Fetch user points balance
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Adds smooth scrolling animation
    });
  });

  useEffect(() => {
    const fetchUserPoints = async () => {
      if (user) {
        try {
          const response = await api.get('/payment/my-wallet');
          setUserPoints(response.data.points_balance || 0);
        } catch (err) {
          console.error('Error fetching user points:', err);
        }
      }
    };

    fetchUserPoints();
  }, [user]);

  // Calculate points value (each point = $0.50)
  const pointsValue = userPoints * 0.5;
  const maxPointsToUse = Math.min(userPoints, Math.floor(cartTotal / 0.5));
  const pointsDiscount = usePoints ? maxPointsToUse * 0.5 : 0;
  const finalTotal = Math.max(0, cartTotal - pointsDiscount);

  const handlePointsChange = (event) => {
    setUsePoints(event.target.checked);
    setPointsError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsProcessing(true);
    setPointsError('');

    // Validate points usage
    if (usePoints && userPoints === 0) {
      setPointsError('You have no points to use');
      setIsProcessing(false);
      return;
    }

    try {
      const response = await api.post('/checkout', {
        shipping_address: shippingAddress,
        payment_method: paymentMethod,
        points_used: usePoints ? maxPointsToUse : 0,
        longitude:shippingPoint.longitude,
        latitude:shippingPoint.latitude
      });

      clearCart();
      navigate(`/order-confirmation/${response.data.id}`);
    } catch (err) {
      console.error('Checkout failed:', err);
      if (err.response?.data?.message === 'Insufficient points balance') {
        setPointsError('Insufficient points balance');
      } else if (err.response?.data?.message === 'Pharmacy closed'){
        alert('الصيدلية مغلقة في الوقت الحالي الرجاء المحاولة لاحقا');
      } else {
        alert('Checkout failed. Please try again.');
      }
    } finally {
      setIsProcessing(false);
    }
  };

  // Calculate original total without discounts
  const originalTotal = cart.reduce((total, item) => {
    return total + (getOriginalPrice(item) * item.quantity);
  }, 0);

  return (
    <Container maxWidth="md" sx={{ py: 4, mb: 10 }}>
      <Typography variant="h4" gutterBottom>
        معلومات الدفع والتوصيل
      </Typography>

      <Paper elevation={3} sx={{ p: 3 }}>
        <form onSubmit={handleSubmit}>
          <Box sx={{ mb: 4 }}>
          <FormLabel component="legend">عنوان التوصيل</FormLabel>
  <div className="search-bar">
    <input
      className="input"
      type="text"
      placeholder={language === "ar" ? keywordsData.search_match_location_place_holder_ar : keywordsData.search_match_location_place_holder_en}
      value={query}
      onChange={(e) => handleQueryChange(e)}
      required
    />
        <Button 
            variant="outlined" 
            sx={{ ...styles.lcathionactionButton, ml: 2 }}
            onClick={handleAutoDetect}
        >
            <MyLocationIcon />
        </Button>
    
    {/* Suggestions dropdown (stays attached to input) */}
    {suggestions.length > 0 && (
      <div className="location-list">
        {suggestions.map((place, index) => (
          <div className="location-item" key={index} onClick={() => handleLocationSelect(place)}>
            {place}
          </div>
        ))}
      </div>
    )}
  </div>
            
          </Box>

          <Box sx={{ mb: 4 }}>
            <FormLabel component="legend">طريقة الدفع</FormLabel>
            <RadioGroup
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
            >
              <FormControlLabel
                value="cash_on_delivery"
                control={<Radio />}
                label="كاش عند التوصيل"
              />
            </RadioGroup>
          </Box>

          {/* Points Redemption Section */}
          {userPoints > 0 && (
            <Box sx={{ mb: 4, p: 2, backgroundColor: 'grey.50', borderRadius: 1 }}>
              <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Loyalty color="primary" /> نقاط مكتسبة
              </Typography>
              
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                <Checkbox
                  checked={usePoints}
                  onChange={handlePointsChange}
                  color="primary"
                />
                <Box>
                  <Typography variant="body1" fontWeight="medium">
                    إستعمل نقاطي المكتسبة
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    لديك {userPoints} نقطة (E.G.P {pointsValue.toFixed(2)})
                  </Typography>
                </Box>
              </Box>

              {usePoints && (
                <Box sx={{ ml: 6 }}>
                  <Alert severity="info" icon={<InfoIcon />} sx={{ mb: 2 }}>
                    <Typography variant="body2">
                      إستعمال {maxPointsToUse} نقطة (E.G.P {pointsDiscount.toFixed(2)}) 
                      من الرصيد المتاح
                    </Typography>
                  </Alert>
                  
                  <Typography variant="body2" color="text.secondary">
                    سيتم تطبيق النقاط كما يلي: <strong>{pointsDiscount.toFixed(2)} جنيه مصري تخفيض</strong>
                  </Typography>
                  
                  <Typography variant="caption" display="block" color="text.secondary" sx={{ mt: 1 }}>
                    * قيمة كل نقطة ٠.٥٠ جنيه مصري. الحد الأقصى للنقاط المطبقة: {maxPointsToUse}
                  </Typography>
                </Box>
              )}

              {pointsError && (
                <Alert severity="error" sx={{ mt: 2 }}>
                  {pointsError}
                </Alert>
              )}
            </Box>
          )}

          <Divider sx={{ my: 2 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              ملخص الطلب
            </Typography>
            
            {/* Savings Banner */}
            {totalSavings > 0 && (
              <Box sx={{ 
                backgroundColor: 'success.light', 
                p: 2, 
                borderRadius: 1, 
                mb: 2,
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }}>
                <Savings color="success" />
                <Box>
                  <Typography variant="subtitle1" color="success.dark" fontWeight="bold">
                    لقد وفرت {totalSavings.toFixed(2)} جنيه مصري على هاذا الطلب!
                  </Typography>
                  <Typography variant="body2" color="success.dark">
                    عروض رائعة على المنتجات المختارة
                  </Typography>
                </Box>
              </Box>
            )}

            <List>
              {cart.map((item) => {
                const currentPrice = getItemPrice(item);
                const originalPrice = getOriginalPrice(item);
                const isDiscounted = hasDiscount(item);
                const discountPercent = isDiscounted 
                  ? Math.round((1 - currentPrice / originalPrice) * 100)
                  : 0;

                return (
                  <ListItem key={item.id} sx={{ alignItems: 'flex-start' }}>
                    <Box sx={{ mr: 2, width: 60, height: 60 }}>
                      <img
                        src={item.product?.imageUrl || noPhoto}
                        alt={item.product?.name}
                        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                      />
                    </Box>
                    
                    <Box sx={{ flexGrow: 1 }}>
                      <Typography variant="subtitle2" fontWeight="medium">
                        {item.product?.name}&nbsp;
                      </Typography>
                      
                      {/* Price Display */}
                      {isDiscounted ? (
                        <Box>
                          <Typography variant="body2" color="error" fontWeight="bold">
                            E.G.P {currentPrice.toFixed(2)} × {item.quantity}
                          </Typography>
                          <Typography 
                            variant="caption" 
                            sx={{ 
                              textDecoration: 'line-through', 
                              color: 'text.secondary' 
                            }}
                          >
                            ${originalPrice.toFixed(2)} each
                          </Typography>
                          <Chip
                            label={`Save ${discountPercent}%`}
                            size="small"
                            color="success"
                            sx={{ ml: 1, height: 20, fontSize: '0.7rem' }}
                          />
                        </Box>
                      ) : (
                        <Typography variant="body2">
                          E.G.P {currentPrice.toFixed(2)} × {item.quantity}
                        </Typography>
                      )}
                    </Box>
                    
                    <Typography variant="subtitle2" fontWeight="bold">
                      E.G.P {(currentPrice * item.quantity).toFixed(2)}
                    </Typography>
                  </ListItem>
                );
              })}
            </List>

            {/* Order Totals */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6">رسوم التوصيل :</Typography>
                  <Typography variant="body2" color="primary.main">
                    E.G.P {deliverFees.toFixed(2)}
                  </Typography>
              </Box>
            <Box sx={{ mt: 3, p: 2, backgroundColor: 'grey.50', borderRadius: 1 }}>
              {totalSavings > 0 && (
                <>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant="body2" color="text.secondary">
                      السعر الإساسي:
                    </Typography>
                    <Typography variant="body2" sx={{ textDecoration: 'line-through' }}>
                      E.G.P {originalTotal.toFixed(2)}
                    </Typography>
                  </Box>
                  
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant="body2" color="success.main">
                      <LocalOffer fontSize="small" sx={{ verticalAlign: 'middle', mr: 0.5 }} />
                      تخفيض:
                    </Typography>
                    <Typography variant="body2" color="success.main">
                      -E.G.P {totalSavings.toFixed(2)}
                    </Typography>
                  </Box>
                </>
              )}

              {usePoints && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography variant="body2" color="primary.main">
                    <Loyalty fontSize="small" sx={{ verticalAlign: 'middle', mr: 0.5 }} />
                    تخقيض النقاط:
                  </Typography>
                  <Typography variant="body2" color="primary.main">
                    -E.G.P {pointsDiscount.toFixed(2)}
                  </Typography>
                </Box>
              )}

              {(totalSavings > 0 || usePoints) && (
                <Divider sx={{ my: 1 }} />
              )}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6">الإجمالي :</Typography>
                <Typography 
                  variant="h5" 
                  color={finalTotal < cartTotal ? 'success.main' : 'primary.main'}
                  fontWeight="bold"
                >
                  E.G.P {finalTotal.toFixed(2)}
                </Typography>
              </Box>

              {(totalSavings > 0 || usePoints) && (
                <Typography variant="body2" color="success.main" textAlign="right" sx={{ mt: 1 }}>
                  قيمة التخفيض: {(totalSavings + pointsDiscount).toFixed(2)} جنيه مصري
                </Typography>
              )}
            </Box>

            {/* Item Count */}
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1, textAlign: 'center' }}>
              {cart.reduce((sum, item) => sum + item.quantity, 0)} منتج في طلبك
            </Typography>
          </Box>

          <Button
            type="submit"
            variant="contained"
            size="large"
            fullWidth
            disabled={isProcessing || cart.length === 0 || finalTotal <= 0}
            sx={{
              backgroundColor: (totalSavings > 0 || usePoints) ? 'success.main' : 'primary.main',
              '&:hover': {
                backgroundColor: (totalSavings > 0 || usePoints) ? 'success.dark' : 'primary.dark'
              },
              py: 1.5,
              fontSize: '1.1rem'
            }}
          >
            {isProcessing ? 'جار المعالجة ...' : (
              finalTotal === 0 ? 'أكمل الطلب بالنقاط' :
              `إطلب ${
                (totalSavings > 0 || usePoints) ? `& وفر ${(totalSavings + pointsDiscount).toFixed(2)} جنيه` : ''
              }`
            )}
          </Button>

          {finalTotal === 0 && (
            <Alert severity="info" sx={{ mt: 2 }}>
              سيتم دفع طلبك بالكامل باستخدام نقاطك المكتسبة!
            </Alert>
          )}
        </form>
      </Paper>
      
      {/* MUI Modal for Google Maps */}
      <GoogleMapModal open={open} handleClose={() => setOpen(false)} onLocationSelect={(location) => handleLocationSelect(location)} initialCenter={selectedLocation} language={language} keywordsData={keywordsData}/>
    </Container>
  );
};

export default CheckoutPage;